<template>
    <div>
      <!-- Popup Overlay -->
      <div v-if="selectedProduct" class="popup-overlay">
        <div class="popup-content">
          <i class="fas fa-times close-icon" @click="selectedProduct = false"></i>
          <div class="popup-image">
            <image-wrap :image="product.main_image" size="large" class="popup-main-image" />
          </div>
        </div>
      </div>
  
      <!-- Product Card -->
      <div class="product-card">
        <div class="card-header">
          <p class="product-sku">Артикул {{ product.sku }}</p>
          <i class="fas fa-search-plus zoom-icon" @click="selectedProduct = product"></i>
        </div>
  
        <a :href="`/product/${product.slug}`" class="product-link">
          <div class="image-wrapper">
            <div v-if="product.sale_price" class="sale-icons">
              <i class="fas fa-tag tag-icon"></i>
              <i class="fas fa-percentage percent-icon"></i>
              <i class="fas fa-map-pin pin-icon"></i>
            </div>
            <image-wrap
              :image="product.main_image"
              size="small"
              class="product-image"
              :srcset="`${product.main_image?.urls.small}, ${product.main_image?.urls.medium}, ${product.main_image?.urls.large}`"
              width="300"
              height="200"
            />
          </div>
        </a>
  
        <div class="product-info">
          <a :href="`/product/${product.slug}`">
            <p class="product-title">{{ product.title }}</p>
            <div class="price-section">
              <span class="price-label">Цена от</span>
              <template v-if="product.sale_price">
                <span class="old-price">₽{{ product.regular_price }}</span>
                <span class="new-price">₽{{ product.price }}</span>
              </template>
              <template v-else>
                <span class="new-price">₽{{ product.price }}</span>
              </template>
            </div>
          </a>
          <div class="order-button">
            <order-popup-btn :product="product" />
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  const props = defineProps(['product'])
  const selectedProduct = ref(null)
  </script>
  
  <style scoped>
  /* === Popup === */
  .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100vw;
    height: 100vh;
    background-color: rgba(60, 87, 87, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(4px);
  }
  .popup-content {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    max-width: 700px;
    width: 90%;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    position: relative;
  }
  .close-icon {
    position: absolute;
    top: 16px;
    right: 16px;
    font-size: 24px;
    cursor: pointer;
    color: #3c5757;
  }
  .close-icon:hover {
    color: #e8cc0f;
  }
  .popup-main-image {
    width: 100%;
    border-radius: 10px;
  }
  
  /* === Product Card === */
  .product-card {
    width: 300px;
    border: 2px solid #3c5757;
    border-radius: 12px;
    overflow: hidden;
    transition: transform 0.3s ease, border 0.3s ease;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .product-card:hover {
    transform: translateY(-4px) scale(1.03);
    border-color: #e8cc0f;
  }
  
  /* Header */
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    color: #3c5757;
  }
  .zoom-icon {
    cursor: pointer;
    transition: color 0.3s;
  }
  .zoom-icon:hover {
    color: #e8cc0f;
  }
  
  /* Image */
  .image-wrapper {
    position: relative;
  }
  .product-image {
    width: 100%;
    height: 300px;
    object-fit: cover;
    border-radius: 0 0 12px 12px;
  }
  .sale-icons i {
    position: absolute;
  }
  .tag-icon {
    font-size: 50px;
    color: red;
    top: 10px;
    left: 80px;
  }
  .percent-icon {
    font-size: 24px;
    color: white;
    top: 20px;
    left: 100px;
  }
  .pin-icon {
    font-size: 20px;
    color: #e8cc0f;
    top: 5px;
    left: 92px;
    transform: rotate(30deg);
  }
  
  /* Info */
  .product-info {
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .product-title {
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    color: #3c5757;
    min-height: 50px;
  }
  .price-section {
    display: flex;
    justify-content: center;
    gap: 10px;
    align-items: center;
    font-size: 16px;
  }
  .price-label {
    color: #e53935;
    background-color: #fff;
  }
  .old-price {
    text-decoration: line-through;
    color: black;
  }
  .new-price {
    color: #3c5757;
    font-weight: bold;
  }
  
  /* Button */
  .order-button {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
  
  /* Responsive Hide Zoom Icon */
  @media screen and (max-width: 620px) {
    .zoom-icon {
      display: none;
    }
    .popup-overlay {
      display: none;
    }
  }
  </style>
  